/*
 * De Hofnar (voormalig CMD Valkenswaard) — theme-specific JS.
 *
 * Aparte bundle naast valkenswaard: beide subthemes bestaan naast elkaar en
 * zijn los kiesbaar via util_options.custom_subtheme. De TPL-laag is (nog)
 * gedeeld — zie de alias-collapse bij elke `assign var=def_subtheme`.
 *
 * De merksite (preview.hofnar.nl) draait op Alpine.js met een
 * `$store.nav` ({ expanded, open, close, toggle }) en een scroll-handler die
 * de header-radius wegdraait. Wij hebben Alpine niet, dus blijft hier het
 * hamburger-gedrag over:
 *
 *   1. Hamburger opent/sluit het menupaneel (klasse `is-open` op knop, paneel
 *      en dim-overlay, `aria-expanded` mee). De knop bestaat TWEE keer — inline
 *      achter het rechter hoofdmenu op desktop en in .hn-header__actions onder
 *      de omslag, net als op de merksite — dus binden we ze allebei en houden
 *      we hun aria-expanded gelijk.
 *   2. ESC sluit.
 *   3. Klik buiten de header sluit — inclusief een klik op de dim-overlay.
 *   4. Resize sluit. De merksite doet hetzelfde (`@resize.window` ->
 *      `$store.nav.close()`): het paneel wisselt op de omslag van volle-breedte
 *      laag naar rechter drawer, en die wissel mag niet halverwege een open
 *      paneel gebeuren.
 *   5. Ouder-items in het paneel klappen hun subnavigatie uit. De merksite
 *      hangt daar `@click.prevent` op dezelfde <a> en wisselt een klasse op de
 *      `.sub-navigation`; wij doen precies dat, met aria-expanded mee.
 *   6. Logo-morph bij scrollen: het woordmerk faadt weg en de hoofdvorm morpht
 *      naar de brand-mark, terug bij scrollen naar boven.
 *
 * jQuery 3.7, GSAP 3 + ScrollTrigger, hc-sticky en doc-cookies staan al op de
 * pagina via de muziekschool-v2 bundle — geen module imports hier (Babel
 * compileert dit bestand in place).
 */

$(function () {
    var $body = $('body');
    if (!$body.hasClass('theme-valkenswaard-hofnar')) return;

    var $header = $('.hn-header');
    var $toggles = $header.find('.hn-navtoggle');
    // Paneel en overlay staan NAAST .hn-header, niet erin: de header vormt met
    // z-index 100 een eigen stacking context, dus een kind kan er nooit onder
    // schuiven. Daarom vanaf document zoeken en niet vanaf $header.
    var $menu = $('.hn-menu').first();
    var $expose = $('.hn-expose').first();

    if (!$toggles.length || !$menu.length) return;

    function isOpen() {
        return $menu.hasClass('is-open');
    }

    function setOpen(open) {
        $menu.toggleClass('is-open', open);
        $expose.toggleClass('is-open', open);
        $toggles.toggleClass('is-open', open);
        $toggles.attr('aria-expanded', open ? 'true' : 'false');
    }

    // 1. Hamburger — beide knoppen; alleen één van de twee is zichtbaar.
    $toggles.on('click', function (e) {
        e.preventDefault();
        setOpen(!isOpen());
    });

    // 2. ESC
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && isOpen()) {
            setOpen(false);
            // Focus terug naar de knop die op deze breedte zichtbaar is.
            $toggles.filter(':visible').first().trigger('focus');
        }
    });

    // 3. Klik buiten de header en buiten de drawer — de overlay valt daar
    //    vanzelf onder.
    $(document).on('click', function (e) {
        if (!isOpen()) return;
        var $t = $(e.target);
        if (!$t.closest('.hn-header').length && !$t.closest('.hn-menu').length) {
            setOpen(false);
        }
    });

    // 4. Resize sluit — zie punt 4 in de kop.
    $(window).on('resize', function () {
        if (isOpen()) {
            setOpen(false);
        }
    });

    // 5. Subnavigatie in het paneel. Gedelegeerd, zodat een extra ouder-item in
    //    de TPL geen JS-aanpassing kost.
    $menu.on('click', '.hn-menu__link--parent', function (e) {
        e.preventDefault();
        var $link = $(this);
        var open = $link.attr('aria-expanded') !== 'true';
        $link.attr('aria-expanded', open ? 'true' : 'false');
        $menu.find('#' + $link.attr('aria-controls')).toggleClass('is-open', open);
    });

    // 7. Inlog-dropdown (issue 38). De accountingang staat twee keer in de
    //    pagina — in de top-pil en bovenaan het paneel — dus gedelegeerd vanaf
    //    document en per instantie schakelen. De merksite doet met Alpine
    //    hetzelfde: `open` per component, `@click.outside` sluit.
    function sluitLogins($behalve) {
        var $open = $('.hn-login.is-open');
        if ($behalve) { $open = $open.not($behalve); }
        $open.removeClass('is-open').find('.hn-login__toggle').attr('aria-expanded', 'false');
    }

    $(document).on('click', '.hn-login__toggle', function (e) {
        e.preventDefault();
        e.stopPropagation();               // anders sluit de outside-handler hem meteen weer
        var $login = $(this).closest('.hn-login');
        var open = !$login.hasClass('is-open');
        sluitLogins($login);
        $login.toggleClass('is-open', open);
        $(this).attr('aria-expanded', open ? 'true' : 'false');
    });

    // Klik buiten de dropdown sluit hem. Losse handler naast punt 3: die kijkt
    // naar de hele header, en de top-pil zit daar juist binnen.
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.hn-login').length) {
            sluitLogins();
        }
    });

    // ESC sluit de dropdown en zet de focus terug op zijn knop. Vóór het
    // paneel: staat de dropdown open, dan is dat wat de bezoeker wil sluiten.
    $(document).on('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var $open = $('.hn-login.is-open');
        if (!$open.length) return;
        e.stopImmediatePropagation();
        $open.find('.hn-login__toggle').first().trigger('focus');
        sluitLogins();
    });

    // Resize sluit, net als bij het paneel: de accountingang wisselt op de
    // omslag van de top-pil naar het paneel.
    $(window).on('resize', function () {
        sluitLogins();
    });
});

/*
 * 6. Logo-morph bij scrollen.
 *
 * Nagebouwd naar de Alpine-component van de merksite:
 *     tl.to('.logo__main', { morphSVG: '.logo__brand-mark', duration: 1,  ease: 'expo.inOut' })
 *       .to('.logo__text', { opacity: 0,                    duration: .8, ease: 'expo.inOut' }, '<');
 *     onScroll() { scrollY > 0 ? tl.play() : tl.reverse() }
 *
 * MorphSVGPlugin is een Club-GreenSock-plugin; die zit in deze repo al in
 * node_modules/gsap en wordt vóór dit bestand in de bundle gezet (zie de
 * ldjn:js-custom-theme-valkenswaard-hofnar-* scripts in package.json).
 *
 * De doelvorm staat als `.hn-logo__mark` met fill="transparent" in dezelfde
 * SVG, zodat hij hetzelfde 100x45-assenstelsel deelt en nooit zichtbaar is.
 */
$(function () {
    if (!$('body').hasClass('theme-valkenswaard-hofnar')) return;

    var logo = document.querySelector('.hn-header__logo svg');
    if (!logo) return;

    var main = logo.querySelector('.hn-logo__main');
    var mark = logo.querySelector('.hn-logo__mark');
    var text = logo.querySelector('.hn-logo__text');
    if (!main || !mark || !text) return;

    // Zonder de plugin liever geen halve animatie: dan blijft het logo heel.
    if (typeof window.gsap === 'undefined' || typeof window.MorphSVGPlugin === 'undefined') return;
    window.gsap.registerPlugin(window.MorphSVGPlugin);

    var tl = window.gsap.timeline({ paused: true });
    tl.to(main, { morphSVG: mark, duration: 1, ease: 'expo.inOut' })
      .to(text, { opacity: 0, duration: 0.8, ease: 'expo.inOut' }, '<');

    var gescrold = null;
    function onScroll() {
        var nu = window.scrollY > 0;
        if (nu === gescrold) return;          // alleen op de omslag, niet elke scroll-tick
        gescrold = nu;
        if (nu) { tl.play(); } else { tl.reverse(); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
});
